import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { IdentityPoolService } from '~src/authentication/services/IdentityPoolService';
import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IServerUser } from '~src/userManagement/users/serverApi/types/IServerUser';
import { ISiteUser } from '~src/userManagement/users/serverApi/types/ISiteUser';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';

import { showIdentityPoolSelectionBasedActionDialog } from './IdentityPoolSelectionBasedAction';

export function removeFromIdentityPoolOnSiteUser(siteUser: ISiteUser): Promise<any> {
  return removeFromIdentityPool(siteUser, (identityPool: IIdentityPool) => IdentityPoolService.removeFromIdentityPoolOnSiteUser(siteUser, identityPool));
}

export function removeFromIdentityPoolOnServerUser(serverUser: IServerUser): Promise<IResult> {
  return removeFromIdentityPool(serverUser, (identityPool: IIdentityPool) => IdentityPoolService.removeFromIdentityPool(serverUser, identityPool));
}

function removeFromIdentityPool(user: IUser, removeAction: (identityPool: IIdentityPool) => Promise<IResult>): Promise<IResult> {
  if (user.poolMemberships && user.poolMemberships.length === 1) {
    const selectedPool = user.poolMemberships[0].identityPool;
    return removeFromSingleIdentityPool(user, selectedPool, () => removeAction(selectedPool));
  } else {
    return removeFromMultipleIdentityPools(user, user.poolMemberships.map(x => x.identityPool), removeAction);
  }

}

function removeFromSingleIdentityPool(user: IUser, identityPool: IIdentityPool, removeAction: () => Promise<IResult>): Promise<IResult> {
  const dialogInstance = openReactConfirmationDialog<void, IResult>({
    title: Messages.identityPools_RemoveFromPoolAction_DialogTitle(),
    message: Messages.identityPools_RemoveFromPoolAction_DialogDescription_SinglePool({
      USER_DISPLAY_NAME: user.displayName,
      IDENTITY_POOL_NAME: identityPool.name
    }),
    paramsForAction: undefined,
    actionName: Messages.identityPools_RemoveFromPoolAction_DialogConfirmButon(),
    action: removeAction,
    isActionDelete: true,
    dialogWidth: TabDialogWidth.width375px
  });

  return dialogInstance.result;
}

function removeFromMultipleIdentityPools(user: IUser, identityPools: IIdentityPool[], myAction: (identityPool: IIdentityPool) => Promise<IResult>): Promise<IResult> {
  return showIdentityPoolSelectionBasedActionDialog(Messages.identityPools_RemoveFromPoolAction_DialogTitle(),
    Messages.identityPools_RemoveFromPoolAction_DialogConfirmButon(), Messages.identityPools_RemoveFromPoolAction_DialogDescription_MultiPool(),
    identityPools, true, myAction);
}
